import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ChatFile, Message, PipelineProgress } from '../../../core/models/api.models';
import { AssistantMessage } from '../assistant-message/assistant-message';
import { EmptyState } from '../empty-state/empty-state';
import { PipelineProgressComponent } from '../pipeline-progress/pipeline-progress';
import { TypingIndicator } from '../typing-indicator/typing-indicator';
import { UserMessage } from '../user-message/user-message';

@Component({ selector: 'app-message-list', standalone: true, imports: [AssistantMessage, EmptyState, PipelineProgressComponent, TranslocoPipe, TypingIndicator, UserMessage], templateUrl: './message-list.html', host: { class: 'block h-full min-h-0' } })
export class MessageList implements OnChanges, AfterViewInit {
  @Input() messages: Message[] = []; @Input() progress: PipelineProgress | null = null; @Input() sending = false; @Input() loading = false; @Input() error: string | null = null;
  @Output() suggestionSelected = new EventEmitter<string>(); @Output() copyRequested = new EventEmitter<string>(); @Output() reaction = new EventEmitter<{ message: Message; reaction: 1 | 2 }>(); @Output() reference = new EventEmitter<ChatFile>(); @Output() dismissError = new EventEmitter<void>();
  @ViewChild('scrollContainer') private scrollContainer?: ElementRef<HTMLElement>; private nearBottom = true;
  protected referenceReveals = new Set<string>();
  protected unstreamedReveals = new Set<string>();
  ngAfterViewInit(): void { this.scheduleScroll(true); }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['messages']) {
      const previous: Message[] = changes['messages'].previousValue ?? [];
      // Tokens and reactions update content in place; no motion bookkeeping.
      if (previous.length !== this.messages.length || previous.at(-1)?.id !== this.messages.at(-1)?.id) {
        const currentIds = new Set(this.messages.map(message => message.id));
        this.referenceReveals = new Set([...this.referenceReveals].filter(id => currentIds.has(id)));
        this.unstreamedReveals = new Set([...this.unstreamedReveals].filter(id => currentIds.has(id)));
        // Final events replace the temporary pair. Animate only new evidence,
        // never the streamed response again or documents from loaded history.
        if (previous.some(message => message.streaming || message.id.startsWith('user-'))) {
          const previousIds = new Set(previous.map(message => message.id));
          const wasStreaming = previous.some(message => message.streaming);
          for (const message of this.messages) {
            if (!message.userMessage && !message.streaming && !previousIds.has(message.id)) {
              this.referenceReveals.add(message.id);
              if (!wasStreaming) this.unstreamedReveals.add(message.id);
            }
          }
        }
      }
    }
    this.scheduleScroll(false);
  }
  protected trackScroll(): void { const el = this.scrollContainer?.nativeElement; if (el) this.nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 180; }
  private scheduleScroll(force: boolean): void { if (!force && !this.nearBottom) return; requestAnimationFrame(() => { const el = this.scrollContainer?.nativeElement; el?.scrollTo({ top: el.scrollHeight, behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }); }
}
